/* eslint-disable jsx-a11y/anchor-is-valid */
import { useContext } from 'react';
import ConfigContext from '../contexts/ConfigContext';
import AppContext from './../contexts/AppContext';

import logoGenability from './../images/logo_genability_grey.png';
import logoFema from './../images/logo_fema_grey.png';
import logoSunroof from './../images/logo_sunroof_grey.png';

declare const sp: any;

export default function Copyright() {
  const { isDebrandedVersion, features } = useContext(ConfigContext);
  const { deBrandedDomain } = useContext(AppContext);
  const currentYear = new Date().getFullYear();

  return (
    <>
      {features.showSunnyBot && (
        <div className="mx-auto mt-10 px-6  max-w-[805px]">
          <div className="border-b border-red-[#DCDCD6] flex justify-center items-center gap-6 md:gap-10 pb-3 md:pb-6">
            <img
              alt=""
              src={logoGenability}
              className="w-[72px] short:w-[72px] md:w-[144px]"
            />
            <img alt="" src={logoFema} className="w-[56px] short:w-[56px] md:w-[96px]" />
            <img alt="" src={logoSunroof} className="w-[96px] short:w-[96px] md:w-[230px]" />
          </div>
        </div>
      )}
      <div
        className={`text-[11px] md:text-[14px] mt-6 mb-5 md:text-center ${
          features.showLanderConcept ? 'text-white' : ''
        } ${features.showSunnyBot ? 'px-6 text-center' : ''}`}>
        Copyright © {currentYear}{' '}
        {isDebrandedVersion ? deBrandedDomain.copyrightText : 'Enphase Energy'}.
        All rights reserved.{' '}
        <CopyLink
          url={`${
            isDebrandedVersion
              ? '/tos#privacy'
              : 'https://enphase.com/legal/privacy-policy'
          }`}
          text="Privacy"></CopyLink>
        ,{' '}
        <CopyLink
          url={`${
            isDebrandedVersion
              ? '/tos'
              : 'https://enphase.com/legal/terms-of-service'
          }`}
          text="Terms &#38; Conditions"></CopyLink>{' '}
          <a
          href="#"
          target="_blank"
          rel="noreferrer"
          className="underline"
          onClick={(e) => {
            e.preventDefault();
            sp.showPrivacyBanner();
          }}>
          Settings / Do not sell or share my
          <br className="md-max:hidden" />
          <span> </span>personal information
          </a>
        ,{' '}
        <CopyLink
          url={`${
            isDebrandedVersion
              ? '/contact-us'
              : 'https://support.enphase.com/s/owner-home?__hstc=100692318.6049799a09bbcc1e9cc14cba412f7f0c.1660067362899.1660067362899.1660067362899.1&__hssc=100692318.1.1660067362899&__hsfp=1542169609'
          }`}
          text="Contact"></CopyLink>
      </div>
    </>
  );
}

function CopyLink({ url, text }: any) {
  return (
    <a href={url} target="_blank" rel="noreferrer" className="underline">
      {text}
    </a>
  );
}
